import { render } from "./TheModalZoom.vue?vue&type=template&id=68e9c9ce"
import script from "./TheModalZoom.vue?vue&type=script&lang=js"
export * from "./TheModalZoom.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Softwaresul\\Projetos Node\\LWP\\Nil Key\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__